export const materials = {
  data () {
    return {}
  },
  methods: {
    dodanie_materialow () {
      Object.values(this.ListaMaterialy).forEach(element => {
        element.sztuk = 0
      })
      Object.keys(this.outputs.akumulators).forEach(element => {
        if (this.outputs.akumulators[element] && Number(this.outputs.akumulators[element].pojemnosc) < 160) {
          this.ListaMaterialy['POZ172BA'].sztuk += 1
          this.ListaMaterialy['MC454'].sztuk += 2
        }
      })
      var iloscKlastrow = this.outputs.qtyClusters.value
      var glebokosc = this.inputs.glebokosc_szafy.value
      // console.log(glebokosc)
      var iloscWentylatorow = this.inputs.panel_wentylacyjny.value
      var iloscMikrofonow = this.inputs.polka_mikrofon.value

      this.ListaMaterialy['ML302'].sztuk += 1
      this.ListaMaterialy['MR014'].sztuk += 1
      this.ListaMaterialy['ML090'].sztuk += 1
      this.ListaMaterialy['ML474'].sztuk += 8
      this.ListaMaterialy['MRAKD1'].sztuk += 1
      this.ListaMaterialy['MD054'].sztuk += (Number(this.outputs.szafa.attributes.wysokosc) > 24) ? 2 : 1.5
      this.ListaMaterialy['MD065'].sztuk += 1.5
      this.ListaMaterialy['MD010'].sztuk += 0.5
      // panel sygnalizacyjny
      this.ListaMaterialy['MC454'].sztuk += 2
      this.ListaMaterialy['ML424'].sztuk += 3

      // na klaster
      this.ListaMaterialy['PKAZ150'].sztuk += (1 * iloscKlastrow)
      this.ListaMaterialy['PKAP476'].sztuk += (5 * iloscKlastrow)

      // glebokosc szafy
      if (glebokosc === 600 || glebokosc === '600') {
        this.ListaMaterialy['POZ172WM'].sztuk += (2 * iloscKlastrow)
        this.ListaMaterialy['POZ172PM'].sztuk += 1
        this.ListaMaterialy['POZ172BM'].sztuk += 1
      } else {
        this.ListaMaterialy['POZ172WD'].sztuk += (2 * iloscKlastrow)
        this.ListaMaterialy['POZ172PD'].sztuk += 1
        this.ListaMaterialy['POZ172BA'].sztuk += 1
      }
      // console.log(iloscWentylatorow, iloscMikrofonow)
      if (iloscWentylatorow === 1 || iloscWentylatorow === '1') {
        this.ListaMaterialy['MC454'].sztuk += 6
        this.ListaMaterialy['ML486'].sztuk += 1
        this.ListaMaterialy['ML485'].sztuk += 5
      }
      if (iloscMikrofonow === 1 || iloscMikrofonow === '1') {
        this.ListaMaterialy['MC454'].sztuk += (4 * iloscMikrofonow)
      }
      // var glebokosc = this.inputs.glebokosc_szafy.value
      // var iloscWzmacniaczy = this.inputs.wzmacniacz.value
      // var iloscWzmacniaczyRezerwowych = this.inputs.wzmacniacz_rezerwowy.value
      // var iloscKontrolerow = this.inputs.kontroler.value
      // var iloscRouterow = this.inputs.router.value

      var cenaPW = 0
      var wagaPW = 0
      var robocizna = 770 + 300 + 1200 // 1200 - 2021.04.27
      var transport = 100

      cenaPW += robocizna
      cenaPW += transport

      Object.values(this.ListaMaterialy).forEach(element => {
        // console.log(element)
        cenaPW += (Number(element.attributes.cena) * element.sztuk)
        wagaPW += (Number(element.attributes.waga) * element.sztuk)
        // console.log(element.kod, element.sztuk, element.attributes.cena, (element.sztuk * element.attributes.cena))
      })

      return {'cena': cenaPW, 'waga': wagaPW}
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/materials.js